import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full lg:max-w-3xl flex justify-center items-center px-5 py-3 shadow border border-base-300 rounded-xl" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "w-full flex flex-row flex-wrap md:flex-nowrap justify-center items-center gap-3" }
const _hoisted_4 = {
  class: "tooltip",
  "data-tip": "List filters"
}
const _hoisted_5 = { class: "tour-config-filters btn btn-ghost text-xl" }

import { ref } from "vue";
import { useHelpStore } from "@/stores";
import { VueFinalModal } from "vue-final-modal";
import PopupButton from "@/components/utils/PopupButton.vue";
import ConfigList from "@/components/config/ConfigList.vue";
import ConfigListFilters from "@/components/config/ConfigListFilters.vue";
import ConfigEdit from "@/components/config/ConfigEdit.vue";
import ConfigWarnings from "@/components/config/ConfigWarnings.vue";
import ConfigModifiedIndicator from "@/components/config/ConfigModifiedIndicator.vue";
import ConfigUpdateButton from "@/components/config/ConfigUpdateButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigInfo',
  setup(__props) {

const help = useHelpStore();

const showDetails = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ConfigModifiedIndicator, { class: "animate-pulse hover:animate-none pl-1 pr-4" }),
      _createVNode(ConfigWarnings, { indicatorClass: "pl-1 pr-4" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ConfigList, { class: "tour-config-list w-full mr-3" }),
      _createVNode(PopupButton, {
        placement: 'bottom-end',
        offset: 3
      }, {
        button: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Icon, { icon: "ic:outline-filter-alt" })
            ])
          ])
        ]),
        popup: _withCtx(() => [
          _createVNode(ConfigListFilters, { class: "p-4" })
        ]),
        _: 1
      }),
      _createVNode(ConfigUpdateButton, { class: "tour-config-save" }),
      _createElementVNode("button", {
        class: "tour-config-details btn btn-neutral",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showDetails.value = !showDetails.value))
      }, " More ")
    ]),
    _createVNode(_unref(VueFinalModal), {
      class: "flex justify-center items-center",
      "content-class": "tour-config-edit modal-box w-full md:max-w-3xl sm:overflow-visible",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => (showDetails.value = v)),
      modelValue: showDetails.value || _unref(help).configDetailsExpand,
      "hide-overlay": false
    }, {
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "font-semibold text-lg" }, "Keyboard configuration", -1)),
        _createVNode(ConfigEdit, { class: "tour-config-edit p-4" })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})